<template>
  <div class="page-wrapper" id="app">
    <Header :pageData="pageData" />
    <main class="page-main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <router-view :pageData="pageData" />
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      pageData: {
        daily: {
          name: "daily",
          previous: "yesterday",
          tableTimePeriod: "Hour",
          jumboDateFormat: "Do MMMM YYYY",
          tableDateFormat: "HH"
        },
        monthly: {
          name: "monthly",
          previous: "yesterday",
          tableTimePeriod: "Date",
          jumboDateFormat: "MMMM YYYY",
          tableDateFormat: "Do"
        },
        yearly: {
          name: "yearly",
          previous: "yesterday",
          tableTimePeriod: "Month",
          jumboDateFormat: "YYYY",
          tableDateFormat: "MMMM"
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "./assets/css/style.css";
</style>
